import React from "react"
import { graphql } from 'gatsby'
import withI18next from "../components/withI18next"
import Layout from "../components/Layout"
import BookingLine from "../components/BookingLine"
import Breadcrumb from "../components/Breadcrumb"
import FamilyDay from "../components/FamilyDay"
import { generateSEOData } from "../helpers/seo"

const FamilyDayPage = ({ pageContext: { localeData }, data }) => {

  const { frontmatter: fields } = data.page
  const { childImageSharp: bgImage } = data.bgImage

  // Generate SEO data for family day page
  const seoData = generateSEOData('familyday', localeData.locale)

  return (
    <Layout
      localeData={localeData}
      title={fields.title}
      keywords={fields.keywords}
      description={fields.description}
      robots={seoData?.robots}
      canonical={seoData?.canonical}
      hreflang={seoData?.hreflang}
    >
      <BookingLine localeData={localeData} />
      <Breadcrumb slug={fields.slug} title={fields.title} bgImage={bgImage} bgOffset="-80" />
      <FamilyDay data={fields} content={data.page.html} />
    </Layout>
  );
};
export default withI18next()(FamilyDayPage);

export const query = graphql`
  query($id: String!) {
    page: markdownRemark(id: { eq: $id })
    {
      html
      frontmatter {
        slug
        title
        subtitle
        contentDescription
        keywords
        description
        questionTitle
        questionDescription
        questionPhone
        questionEmail
        blockquote        
        image {
          childImageSharp {
            fluid(maxWidth: 770, quality: 90) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    bgImage: file(relativePath: { eq: "gatherings/familyday/familyday-2_bg.jpg" }) {
      childImageSharp {
        fluid(quality: 50, maxWidth: 1500) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    
  }`